<div *ngIf="isHomePage && apiProductUpdatesTitle && apiProductUpdates">
  <h5>{{ apiProductUpdatesTitle }}</h5>
  <div class="tbrow">
    <div class="col-4 col-sm-3">Live Date</div>
    <div class="col-2 col-sm-2">Status</div>
    <div class="col-6 col-sm-6">Title</div>
  </div>

  <div *ngFor="let revisionNotice of apiProductUpdates">
    <a href="{{ revisionNotice.url }}" class="td-link">
      <div class="itmrow">
        <div class="col-sm-3 col-4 flex-sm-nowrap">{{ revisionNotice.liveDate | dateFormat }}</div>
        <div class="col-sm-2 col-2">{{ revisionNotice.status }}</div>
        <div class="col-sm-6 col-6"><i class="fa fa-info-circle thead-grey"></i> {{ revisionNotice.title }} <span
            class="sml"> </span></div>
      </div>
    </a>
  </div>
</div>

<div *ngIf="isIagPotalPage && iagProductUpdatesTitle && iagProductUpdate">
  <h5>{{ iagProductUpdatesTitle }}</h5>
  <div class="tbrow">
    <div class="con-sm-4 col-lg-3">Live Date</div>
    <div class="con-sm-4 col-lg-2">Status</div>
    <div class="con-sm-4 col-lg-6">Title</div>
  </div>

  <div *ngFor="let iagRevisionNotice of iagProductUpdate">
    <a href="{{ iagRevisionNotice.url }}" class="td-link">
      <div class="itmrow">
        <div class="col-4 col-sm-3 flex-sm-nowrap">{{ iagRevisionNotice.liveDate | dateFormat }}</div>
        <div class="col-2 col-sm-2">{{ iagRevisionNotice.status }}</div>
        <div class="col-6 col-sm-6"><i class="fa fa-info-circle thead-grey"></i> {{ iagRevisionNotice.title }} <span
            class="sml"> </span></div>
      </div>
    </a>
  </div>
</div>

<div *ngFor="let tableSection of tableSections" class="latestapi-home">
  <div
    *ngIf="!isHomePage && !isFileAssetsPage && !isRevisionNoticesPage && !isPaymentsNdcCommercialFaqPage && tableSection.table"
    class="CommonTable">
    <h3>{{ tableSection.title }}</h3>
    <div [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>

  <div
    *ngIf="!isHomePage && !isFileAssetsPage && !isRevisionNoticesPage && !isPaymentsNdcCommercialFaqPage && tableSection.body"
    class="CommonTable">
    <h3 id="{{ tableSection.title }}">{{ tableSection.title }}</h3>
    <div [innerHTML]="tableSection.body | mdToHtml"></div>
  </div>

  <div *ngIf="isRevisionNoticesPage" class="CommonTable">
    <h3>{{ tableSection.title }}</h3>
    <div [innerHTML]="tableSection.body | mdToHtml"></div>
    <div [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
  <div *ngIf="isPaymentsNdcCommercialFaqPage" class="blueTable">
    <h4>{{ tableSection.title }}</h4>
    <div [innerHTML]="tableSection.body | mdToHtml"></div>
    <div [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>